import useMutation from "./mutation";
import useQuery from "./query";

/* eslint-disable react-hooks/rules-of-hooks */
export const api = {
    get: <T = any>(url: string, variables?: any, disabled?: boolean) =>
        useQuery<T>(url, variables, disabled),
    post: (url: string) => useMutation("post", url),
    patch: (url: string) => useMutation("patch", url),
    put: (url: string) => useMutation("put", url),
    delete: (url: string) => useMutation("delete", url),
};
